"use client";

import { defaultLayout } from "@/lib/schema/settings";
import { TResume } from "@/lib/store/resume";
import { getFontVariableFamily } from "@/utils/fonts";
import classNames from "classnames";
import { motion } from "framer-motion";
import {
  forwardRef,
  Suspense,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { Page } from "../builder/Page";
import { getTemplate } from "../builder/template";
import Init from "./Init";

export type AppRef = {
  measureLayout: () => {
    pageCount: number;
    isMultiPage: boolean;
  };
};

const Preview = forwardRef<
  AppRef,
  {
    resume: TResume;
    mode?: "preview" | "builder" | "print";
  }
>(function App({ resume, mode }, ref) {
  const layout = resume.data.settings?.layout || defaultLayout;

  const template = resume.data.settings?.template || "azurill";

  const font = resume.data.settings?.typography?.font?.family;

  const Template = getTemplate(template);

  // 创建一个状态来保存页数
  const [pageCount, setPageCount] = useState(1);

  // 暴露测量方法给父组件
  useImperativeHandle(ref, () => ({
    measureLayout: () => ({
      pageCount,
      isMultiPage: pageCount > 1,
    }),
  }));

  const mergeColumns = useMemo(() => {
    let result: string[][] = [[], []];
    layout.forEach((res) => {
      result[0] = [...result[0], ...res[0]];
      result[1] = [...result[1], ...res[1]];
    });
    return result;
  }, [layout]);

  const pageIndex = 1;

  return (
    <>
      {/* {layout.map((columns, pageIndex) => ( */}
      <motion.div
        layout
        key={pageIndex}
        initial={{ opacity: 0, y: 20, x: 0 }}
        animate={{
          opacity: 1,
          x: 0,
          y: 0,
          transition: { delay: pageIndex * 0.3 },
        }}
        exit={{ opacity: 0, y: -200 }}
      >
        <Init resume={resume} />

        <Suspense>
          <Page
            key={pageIndex}
            mode={mode}
            pageNumber={pageIndex + 1}
            marginPx={resume.data.settings?.page.margin}
            resume={resume}
            onPagesChange={setPageCount}
          >
            <div
              className={classNames("resume leading-resume")}
              style={{
                fontFamily: `${getFontVariableFamily(resume.data.settings?.typography.font.family || "roboto")}`,
              }}
            >
              <Template
                isFirstPage={true}
                columns={mergeColumns as any}
                resume={resume}
              />
            </div>
          </Page>
        </Suspense>
      </motion.div>
      {/* ))} */}
    </>
  );
});

export default Preview;
